export const buildAddressFromComponents = (components) => {
  if (!Array.isArray(components) || components.length === 0) return "";

  const get = (type) =>
    components.find((c) => c.types?.includes(type))?.long_name || "";

  const street = [get("street_number"), get("route")].filter(Boolean).join(" ");
  const area =
    get("sublocality_level_1") ||
    get("sublocality") ||
    get("neighborhood") ||
    get("administrative_area_level_3");
  const city = get("locality") || get("administrative_area_level_2");
  const state = get("administrative_area_level_1");
  const country = get("country");

  return [street, area, city, state, country].filter(Boolean).join(", ");
};

export const resolvePlaceDisplayAddress = (place, inputValue = "") => {
  const typed = String(inputValue ?? "").trim();
  const formatted = place?.formatted_address?.trim() || "";
  const fromComponents = buildAddressFromComponents(place?.address_components);
  const name = place?.name?.trim() || "";

  if (typed) return typed;
  return formatted || fromComponents || name;
};
